// /control — «Контроль» (003, сценарий 5): таблица открытых пунктов. Право — control.read;
// какие документы видны, решает сервер по областям. Поиск, фильтры, вид и сортировка — в адресе
// под именами запроса control.items: /control?asOf=today&group=overdue (приёмка 0.3.1, T041).
//
// 045 (OPN-21, OPN-22; research Р9): список приходит вместе со страницей. Загрузчик берёт пункты
// по условиям адреса и список документов (варианты «Документа»), и при предзагрузке — наведение
// и фокус на пункте меню. Переход ждёт данных до 300 мс — до этого видна прежняя страница, дальше
// каркас «Контроля» со скелетом строк в форме таблицы (ControlPending; ревью 045, T041). Смена
// условий на самой странице не ждёт: строки остаются до новых (keepPreviousData в ControlPage).
// Сбой загрузки — не экран ошибки маршрута: его показывает страница со своим «Повторить».
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { apiQuery } from '../../api/client.ts';
import { ControlPage, ControlPending } from '../../features/control/ControlPage.tsx';
import { controlQuery, parseControlSearch } from '../../features/control/search.ts';
import type { ControlSearch } from '../../features/control/search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/control')({
  validateSearch: parseControlSearch,
  beforeLoad: requireSection('control'),
  loaderDeps: ({ search }) => controlQuery(search),
  loader: async ({ context, deps, cause }) => {
    if (cause === 'stay') return;
    await Promise.allSettled([
      context.queryClient.ensureQueryData(apiQuery('control.items', { query: deps })),
      context.queryClient.ensureQueryData(apiQuery('documents.list')),
    ]);
  },
  staticData: { crumb: 'Контроль' },
  pendingComponent: ControlRoutePending,
  component: ControlRoute,
});

function ControlRoutePending() {
  return <ControlPending search={Route.useSearch()} />;
}

function ControlRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onSearchChange = useCallback(
    (next: ControlSearch) => void navigate({ to: '/control', search: next, replace: true }),
    [navigate],
  );
  return <ControlPage search={search} onSearchChange={onSearchChange} />;
}
